//
//
//
//
//
//
//

// +---------------------------------------------------------------------
// | CNXRC [ CNXRC赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.cnxrc.net All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CNXRC并不是自由软件，未经许可不能去掉CNXRC相关版权
// +---------------------------------------------------------------------
// | Author: CNXRC Team <admin@cnxrc.net>
// +---------------------------------------------------------------------
import AreaMenuComponent from './AreaMenuComponent.vue';
export default {
  name: 'AreaMenu',
  components: {
    AreaMenuComponent: AreaMenuComponent
  }
};